/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ThemeComponent } from './theme.component';
import { PluginModule, CommonModule as GridCommonModule, TemplateModule, PipeModule, GridModule, VscrollModule, ThemeService } from 'ng2-qgrid';
export class ThemeModule {
    /**
     * @param {?} theme
     */
    constructor(theme) {
        theme.name = 'basic';
        theme.component = ThemeComponent;
    }
}
ThemeModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    ThemeComponent
                ],
                exports: [
                    ThemeComponent
                ],
                imports: [
                    CommonModule,
                    GridCommonModule,
                    FormsModule,
                    TemplateModule,
                    GridModule,
                    PluginModule,
                    PipeModule,
                    VscrollModule
                ],
                entryComponents: [
                    ThemeComponent
                ]
            },] },
];
/** @nocollapse */
ThemeModule.ctorParameters = () => [
    { type: ThemeService }
];
//# sourceMappingURL=theme.module.js.map